import { c as _c } from "react/compiler-runtime";
// Loading placeholder for the right column of the markets feed hero row.
// Mirrors the live state — `breaking-views-widget.tsx` (Hot Takes carousel
// card) followed by `top-markets-by-prize-widget.tsx` (prize card). Both
// widgets ALSO render these same card skeletons while their own queries are
// pending (the route skeleton unmounts once the featured-hero query settles),
// so the right column never goes blank between hand-offs.

import { cn } from '@/lib/ui/utils';
import { HotTakesCardSkeleton } from './hot-takes-card-skeleton';
import { PrizePoolsCardSkeleton } from './prize-pools-card-skeleton';
export interface RightColumnSkeletonProps {
  className?: string;
}
export function RightColumnSkeleton(props) {
  const $ = _c(6);
  const {
    className
  } = props;
  let t0;
  if ($[0] !== className) {
    t0 = cn("flex min-h-0 flex-1 flex-col gap-3", className);
    $[0] = className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HotTakesCardSkeleton testId="breaking-views-skeleton-card" />;
    t2 = <PrizePoolsCardSkeleton testId="top-markets-by-prize-skeleton-card" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0) {
    t3 = <section aria-busy={true} aria-live="polite" data-testid="right-column-skeleton" className={t0}>{t1}{t2}</section>;
    $[4] = t0;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}